import { AxiosInstance } from "axios";
import { Dispatch } from "redux";
import { IStateTree } from "../../interfaces";
import { showNotification } from "../../notification/actions";
import { IPack } from "../models";
import { DashboardActionTypes } from "../models/dashboardActions";
import { GET_PACKS } from "../types";

export default (callback: (packs: IPack[]) => void) => async (dispatch: Dispatch<DashboardActionTypes>, getState: () => IStateTree, api: AxiosInstance) => {
    try {
        dispatch({
            type: GET_PACKS,
            payload: {
                loading: true,
            },
        });
        const res = await api.get<{ packs: IPack[] }>("/packs");
        if (callback) callback(res.data.packs);
        dispatch({
            type: GET_PACKS,
            payload: res,
        });
    } catch (error) {
        dispatch(showNotification(error.message, "warning"));
        dispatch({
            type: GET_PACKS,
            payload: {
                error: true,
            },
        });
    }
};
